/* This file is autogenerated, see readme.md for instructions */
import FolderEmptySvgIcon from '@bloomreach/banana-theme/icons/folder-empty.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FolderEmptyIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FolderEmptySvgIcon />
    </Icon>
  );
});

FolderEmptyIcon.displayName = 'FolderEmptyIcon';

export default FolderEmptyIcon;
